import { ROUTES, featureTypes } from "@/utils/navigation";
import { Container } from "@mui/material";
import { useEffect } from "react";
import { useNavigate, useParams } from "react-router";
import Breadcrumb from "@/components/UI-Kit/Breadcrumb";
import TelematicsInsightsSection from "./components/TelematicsInsightsSection";
import MeetInDetailsSection from "./components/MeetInDetailsSection";
import OtherFeaturesSection from "./components/OtherFeaturesSection";
import QuestionsSection from "./components/QuestionsSection";

const FeatureDetails = () => {
  const { type } = useParams();
  const navigate = useNavigate();

  useEffect(() => {
    if (!type) {
      navigate(ROUTES.features);
    } else {
      // Check if the type is valid
      const isValidType = featureTypes.includes(type);

      // Redirect to NotFound if type is not valid
      if (!isValidType) {
        navigate(ROUTES.features);
      }
    }
  }, [navigate, type]);

  return (
    <>
      <Container
        sx={{
          paddingTop: { xs: 3, lg: 0 },
          paddingBottom: { xs: 4, lg: 7.25 },
        }}
      >
        <Breadcrumb
          options={[
            {
              label: "Main features",
              href: ROUTES.features,
            },
            {
              label: "Real-Time telematics insights",
            },
          ]}
        />
      </Container>
      <TelematicsInsightsSection />
      <MeetInDetailsSection />
      <OtherFeaturesSection />
      <QuestionsSection />
    </>
  );
};

export default FeatureDetails;
